import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { checkUrl } from '../deployment'

@Injectable({
  providedIn: 'root'
})
export class EcaadminDashboardService {

  constructor(
    private http: HttpClient,
    private router: Router
  ) {}

  login($data: any) {
    return this.http.post(checkUrl()+"/ecademic/admin/login",$data)
    .pipe((response)=>{
      return response;
    });
  }
    
  sessionList(){
    return this.http.get(checkUrl()+"/ecademic/session/list").pipe((response)=>{
      return response;
    });
  }

  //requirment _id
  userDetails($data:any) {
    return this.http.post(checkUrl()+"/ecademic/admin/details",$data)
    .pipe((response)=>{
      return response;
    });
  }

  

   //sud admin session alloted (reqired userId, sessionId)
   allotedSession($data) {
    return this.http.post(checkUrl()+"/ecademic/session/alloted",$data)
    .pipe((response)=>{
      return response;
    });
   }

   //delete the subadmin,user,tutor
   deleteUser($data){
    return this.http.post(checkUrl()+"/ecademic/admin/delete",$data)
    .pipe((response)=>{
      return response;
    });
   }
   
   userList($data:any){
    return this.http.post(checkUrl()+"/ecademic/admin/list",$data)
    .pipe((response)=>{
      return response;
    });
  }
   //session list for specific user (requirment userId)
   SpecificUserSessionList($data){
    return this.http.post(checkUrl()+"/ecademic/admin/subadminSessionList",$data)
    .pipe((response)=>{
      return response;
    });
   }

  // (requirment userId)
   SubAdminSessionList($data){
    return this.http.post(checkUrl()+"/ecademic/admin/sessionList",$data)
    .pipe((response)=>{
      return response;
    });
   }

   //Specific sub admin details
   SubAdminDetails($data){
    return this.http.post(checkUrl()+"/ecademic/admin/sub-admin/details",$data)
    .pipe((response)=>{
      return response;
    });
  }

  messageList($data:any){
    return this.http.post(checkUrl()+"/ecademic/message/list",$data)
    .pipe((response)=>{
      return response;
    });
}
}


